import type { Article } from "./types";

export const weddingPlanningChecklist: Article = {
  slug: "wedding-planning-checklist",
  published: true,
  publishedAt: "2026-10-27",
  updatedAt: "2026-10-27",
  title: {
    ro: "Checklist organizare nuntă și botez: pașii esențiali",
    en: "Wedding and baptism planning checklist: essential milestones",
  },
  summary: {
    ro: "Lista practică de pași pentru organizarea nunții, a botezului sau a evenimentului combinat, de la alegerea datei până la așezarea la mese.",
    en: "A practical step-by-step checklist for planning a wedding, baptism or combined celebration, from picking the date to seating guests.",
  },
  body: {
    ro: [
      { t: "h2", text: "Cu 6–12 luni înainte: data, locațiile și pagina evenimentului" },
      {
        t: "p",
        text: "După ce ai stabilit data și locațiile pentru cununia civilă, cununia religioasă, slujba de botez și petrecere, creează pagina evenimentului pe Jubiel.",
      },
      {
        t: "ul",
        items: [
          "Completează numele mirilor sau ale copilului, părinților și nașilor.",
          "Activează momentele evenimentului și adaugă adresele pentru Google Maps și Waze.",
          "Configurează opțiunile de meniu (standard, vegetarian, vegan) și cazare.",
        ],
      },
      { t: "h2", text: "Cu 2–4 luni înainte: trimiterea invitațiilor și colectarea RSVP" },
      {
        t: "p",
        text: "Importă lista inițială de invitați din CSV sau adaugă familiile manual, apoi trimite link-urile scurte pe WhatsApp.",
      },
      { t: "h2", text: "În ultima săptămână: aranjarea la mese și exportul pentru sală" },
      {
        t: "p",
        text: "După data limită RSVP, alocă fiecare familie confirmată la masă (de exemplu „Masa 1”, „Masa 2”) și descarcă tabelul CSV complet cu meniuri, copii și mese pentru organizatorul sălii.",
      },
    ],
    en: [
      { t: "h2", text: "6–12 months before: date, venues and your event page" },
      {
        t: "p",
        text: "Once you have set the date and venues for the civil ceremony, religious wedding, baptism service and reception, create your event page on Jubiel.",
      },
      {
        t: "ul",
        items: [
          "Fill in the names of the couple or baby, parents and godparents.",
          "Enable your event moments and add addresses for Google Maps and Waze.",
          "Configure meal options (standard, vegetarian, vegan) and accommodation.",
        ],
      },
      { t: "h2", text: "2–4 months before: sending invitations and collecting RSVPs" },
      {
        t: "p",
        text: "Import your initial guest list from CSV or add households manually, then share personalized short links on WhatsApp.",
      },
      { t: "h2", text: "Final week: table seating and exporting for the venue" },
      {
        t: "p",
        text: "After the RSVP cutoff date, assign each confirmed household to a table (such as “Table 1”, “Table 2”) and download the complete CSV sheet with meals, kids and tables for the venue coordinator.",
      },
    ],
  },
};
